package com.essntl.uikit.components.utils

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.RowScope
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextOverflow
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun RowScope.EsRowDefaultItem2(
    text: String?,
    weight: Float = 1f,
    maxLines: Int = 1,
) {
    EsRowItem2(
        weight = weight,
    ) {
        Text(
            text = text ?: "",
            color = MaterialTheme.esColorScheme.textPrimary,
            style = MaterialTheme.esTypography.p1Regular16,
            maxLines = maxLines,
            overflow = TextOverflow.Ellipsis,
        )
    }
}

@Composable
fun RowScope.EsRowItem2(
    weight: Float = 1f,
    content: @Composable () -> Unit = {},
) {
    Box(
        modifier = Modifier.weight(weight),
    ) {
        content()
    }
}